import { useContext } from 'react';
import { SidebarContext } from './SidebarContext';

// TODO remove it when LegacySideBar will be removed from the codebase
export function useSidebarContext() {
  return useContext(SidebarContext);
}
